import gql from 'graphql-tag';

export const LogicalEntityQuery=gql`

query LogicalEntity($id:ID!)
{
    LogicalEntity(id:$id){
      name
    configObjectId
    configObjectType
    createdBy
    isDeleted
    itemDescription
    insert_ts
    projectId
    updatedBy
    update_ts
    deletionDate
    dbTypeName
    supportedFlavor
    generateSkeleton
      childRelations {
          relationType
          childItemId
          insert_ts
          update_ts
          createdBy
          updatedBy
        }
        parentRelations {
          relationType
          parentItemId
          insert_ts
          update_ts
          createdBy
          updatedBy
        }
        privileges {
          privilegeType
          roleId
          insert_ts
          update_ts
          createdBy
          updatedBy
        }
        
}
}`;